import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ModalForm.css";
import formGirl from "../images/form-girl.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";
const Modal = ({ show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const modalRef = useRef(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [show, handleClose]);

  const handlePhoneChange = (phone) => {
    setFormData((prev) => ({
      ...prev,
      Number: phone || "", // Ensure phone is a string
    }));
  };
  const [formData, setFormData] = useState({
    FName: "",
    LastName: "",
    Email: "",
    Company: "",
    Sales: "",
    Message: "",
    Number: "",
    Location: "",
  });

  const resetForm = () => {
    setFormData({
      FName: "",
      LastName: "",
      Email: "",
      Company: "",
      Sales: "",
      Message: "",
      Number: "",
      Location: "",
    });
  };

  const validateForm = () => {
    const errors = [];
    
    // Required field validation
    if (!formData.FName.trim()) errors.push("First Name is required");
    if (!formData.LastName.trim()) errors.push("Last Name is required");
    if (!formData.Email.trim()) errors.push("Email is required");
    if (!formData.Company.trim()) errors.push("Company is required");
    if (!formData.Message.trim()) errors.push("Message is required");
    if (!formData.Number.trim()) errors.push("Phone Number is required");
    if (!formData.Location.trim()) errors.push("Location is required");

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.Email && !emailRegex.test(formData.Email)) {
        errors.push("Please Enter A Valid Email Address");
    }

    // Phone number validation (basic check for minimum length)
    if (formData.Number && formData.Number.length < 10) {
        errors.push("Please Enter A Valid Phone Number");
    }

    return errors;
};

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form before submission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
        validationErrors.forEach(error => toast.error(error));
        return;
    }

    setLoading(true);

    try {
        const response = await fetch(
            "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBT",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        );

        if (response.ok) {
            await response.json();
            toast.success("Enquiry Submitted. Our Team Will Contact You Shortly.");
            resetForm();
        } else {
            toast.error("Failed To Submit The Form. Please Try Again Later.");
        }
    } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An Error Occurred While Submitting The Form.");
    } finally {
        setLoading(false);
    }
};
  return (
    <>
      {/* Backdrop */}
      {show && <div className="modal-backdrop fade show"></div>}

      {/* Modal */}
      <div
        className={`modal fade ${show ? "show" : ""}`}
        style={{ display: show ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!show}
        role="dialog"
      >
        <div className="modal-dialog modal-lg" ref={modalRef}>
          <div className="modal-content border-0 bg-transparent">
            <div className="modal-body p-0">
              <div className="container my-lg-5 ps-lg-5 pe-lg-5 p-0">
                <div className="card">
                  <div className="row">
                    <div className="col-lg-7 col-md-12">
                      <div className="card-body ps-lg-4 pt-lg-4 pb-lg-4">
                        <h2 className="card-title headings text-start ms-2">
                          <span className="drop-color">Drop</span> Us A Line
                        </h2>
                        <form
                          className="common-form grotesk-headings"
                          onSubmit={handleSubmit}
                        >
                          <div className="first-grp d-flex gap-1 mt-4">
                            <input
                              type="text"
                              name="FName"
                              placeholder="First Name"
                              className="form-control p-xxl-2 p-2"
                              value={formData.FName}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  FName: e.target.value,
                                })
                              }
                              required
                            />
                            <input
                              type="text"
                              name="LastName"
                              placeholder="Last Name"
                              className="form-control p-xxl-2 p-2"
                              value={formData.LastName}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  LastName: e.target.value,
                                })
                              }
                              required
                            />
                          </div>
                          <div className="first-grp d-flex gap-1 mt-lg-2 mt-md-2 mt-2">
                            <input
                              type="text"
                              name="Location"
                              placeholder="Location"
                              className="form-control p-xxl-2 p-2"
                              value={formData.Location}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  Location: e.target.value,
                                })
                              }
                              required
                            />
                            <input
                              type="text"
                              name="Email"
                              placeholder="Email"
                              className="form-control p-xxl-2 p-2"
                              value={formData.Email}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  Email: e.target.value,
                                })
                              }
                              required
                            />
                          </div>
                          <div className=" d-flex  gap-2 mt-md-2 mt-lg-2 mt-xxl-2 mt-2">
                            <PhoneInput
                              country={"gb"}
                              value={formData.Number}
                              onChange={handlePhoneChange}
                              inputClassName="form-control"
                              containerClass="phone-input-container"
                              className="modal-phone-container"
                              inputProps={{
                                name: "Number",
                                required: true,
                                placeholder: "Phone Number",
                              }}
                              enableSearch={true}
                              preferredCountries={["gb", "us", "in"]}
                              required
                            />
                          </div>
                          <input
                            type="text"
                            name="Company"
                            placeholder="Company Name"
                            className="form-control mt-2"
                            value={formData.Company}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                Company: e.target.value,
                              })
                            }
                            required
                          />
                          <textarea
                            name="Message"
                            placeholder="Message"
                            className="form-control mt-md-1 mt-lg-2 pb-md-3 mt-xxl-2 mt-2 pb-4"
                            rows="3"
                            value={formData.Message}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                Message: e.target.value,
                              })
                            }
                            required
                          ></textarea>
                          <div className="carouselCaption mt-3">
                            {/* <button
                              className="btn text-dark bg-white fs-4 p-2 fw-bold text-center form-control rounded-pill shadow"
                              type="submit"
                            >
                              SUBMIT
                            </button> */}
                            <button className="btn text-dark bg-white fs-4 p-2 fw-bold text-center form-control rounded-pill shadow" type="submit" disabled={loading} >
                              {loading ? 'Loading...' : 'SUBMIT'}
                            </button>
                          </div>
                        </form>
                      </div>
                      <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        style={{ zIndex: 9999999999 }}
                      />
                    </div>
                    <div className="col-md-5 form-img">
                      {/* Close icon */}
                      <i
                        className="bi bi-x popupformContactIcon"
                        onClick={handleClose}
                      ></i>
                      <LazyLoadImage
            effect="blur"

                        src={formGirl}
                        alt="Card"
                        className="popupformContact"   loading="lazy" 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Close Button */}
            {/* <button type="button" className="btn-close position-absolute top-0 end-0 m-3" aria-label="Close" onClick={handleClose}></button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
